export const columns = [
  {
    title: 'Prenume',
    field: 'firstName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Nume',
    field: 'lastName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Adresa de mail',
    field: 'email',
    align: 'left',
    type: 'string'
  }
]